import React from 'react'
import styled from 'styled-components'
import { graphql } from 'gatsby'
import SEO from '../components/SEO'
import BlockRenderer from '../components/shared/BlockRenderer'

const Page = ({
  location,
  data: {
    contentfulPage: {
      name,
      componentBlocks,
      seoTitle,
      seoDescription,
      seoImage,
      layoutType,
    },
    allTrustPilotSummary: {
      nodes: [
        {
          score: { trustpilotStars },
          totalNumberOfReviews,
        },
      ],
    },
  },
}) => {
  const hasTileBlock =
    componentBlocks &&
    componentBlocks.some(
      ({ __typename }) => __typename === 'ContentfulTileBlock',
    )

  return (
    <PageWrapper data-layout-type-name={layoutType && layoutType.name}>
      <SEO
        isPage
        location={location}
        title={seoTitle}
        description={seoDescription}
        image={
          seoImage?.file?.url ||
          (componentBlocks?.[0]?.heroImage &&
            componentBlocks[0].heroImage.file.url)
        }
        noIndex={layoutType && layoutType.noIndex}
        pageCategory={hasTileBlock ? 'Category' : 'Landing'}
        referrer={location.state?.referrer}
      />
      <BlockRenderer
        blocks={componentBlocks}
        location={location}
        rating={{
          totalNumberOfReviews,
          trustpilotStars,
        }}
      />
    </PageWrapper>
  )
}

const PageWrapper = styled.div``

export const PageQuery = graphql`
  query Page($id: String!) {
    contentfulPage(id: { eq: $id }) {
      name
      seoTitle
      seoDescription
      seoImage {
        file {
          url
        }
      }
      layoutType {
        name
        noIndex
      }
      componentBlocks {
        ...pageBlocks
      }
    }
    allTrustPilotSummary {
      ...pageRatings
    }
  }
`

export default Page
